import { useEffect } from 'react';

const ACTION_LABELS = {
  exa_sweep: 'sweep this company for signals',
  claude_research: 'run advanced research on this company',
  claude_sequence: 'generate a sequence for this contact',
  find_companies: 'search for new companies',
};

export default function OutOfCreditsModal({ open, error, onClose, onTopUp }) {
  useEffect(() => {
    if (!open) return;
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const action = error?.action || 'this action';
  const actionLabel = ACTION_LABELS[action] || action.replace(/_/g, ' ');
  const needed = error?.credits_needed ?? '?';
  const have = error?.balance ?? 0;
  const shortfall = error?.shortfall ?? Math.max(0, needed - have);

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: '12px', padding: '2rem', maxWidth: '460px', width: '90%', boxShadow: '0 20px 50px rgba(0,0,0,0.25)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', marginBottom: '0.85rem' }}>
          <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#FFF5F5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C53030" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <h2 style={{ margin: 0, fontSize: '1.15rem', fontWeight: '700', color: '#1A1A1A' }}>Out of credits</h2>
        </div>

        <p style={{ margin: '0 0 1rem', fontSize: '0.9rem', color: '#4A5568', lineHeight: '1.55' }}>
          You need <strong>{needed} credit{needed === 1 ? '' : 's'}</strong> to {actionLabel}, but you only have <strong>{have}</strong>.
        </p>

        <div style={{ background: '#FAFAF8', borderRadius: '8px', padding: '0.85rem 1rem', marginBottom: '1.25rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '0.78rem', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '600' }}>Shortfall</span>
          <span style={{ fontSize: '1.1rem', fontWeight: '700', color: '#C53030' }}>{shortfall} credit{shortfall === 1 ? '' : 's'}</span>
        </div>

        <div style={{ display: 'flex', gap: '0.6rem' }}>
          <button onClick={onClose} style={{ flex: 1, padding: '0.7rem', fontSize: '0.85rem', fontWeight: '500', background: '#fff', color: '#4A5568', border: '1px solid #D4CFC9', borderRadius: '6px', cursor: 'pointer' }}>
            Cancel
          </button>
          <button onClick={() => { onClose(); onTopUp && onTopUp(); }} style={{ flex: 1, padding: '0.7rem', fontSize: '0.85rem', fontWeight: '600', background: '#8B1A1A', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
            Top up credits
          </button>
        </div>
      </div>
    </div>
  );
}
